/**
 * Un documento emitido en contingencia sigue pendiente de transmitirse a Hacienda: se entrega al
 * receptor, pero todavia no tiene sello de recepcion. Mostrarlo como "Procesado" junto a los que si
 * fueron sellados oculta esa diferencia, que es justo la que el emisor necesita ver.
 *
 * Se mira el estado del ciclo de contingencia y, como respaldo, el sello: mientras vale
 * "CONTINGENCIA" el documento no ha sido aceptado. Al transmitirlo, el sello real de Hacienda
 * sustituye a ese texto y el documento pasa a "Procesado" por si solo.
 */
const enContingencia = (data: any): boolean => {
  const { esContingencia, estadoContingencia, sellorecibido } = data;

  if (estadoContingencia === 'TRANSMITIDO') return false;

  return esContingencia === true || sellorecibido === 'CONTINGENCIA';
};

const pasoPorContingencia = (data: any): boolean => data?.estadoContingencia === 'TRANSMITIDO';

export const renderEstadoDoc = (
    data: any,
    opciones: { esTransaccion?: boolean, esDocRelacionado?: boolean, addClass?: string } = {}
  ): any => {
    const { estadoanulacion, detallenota, notificarcorreo, anulado, estado, estadoContingencia } = data;
    const ajustado = detallenota?.some((nota: any) => nota.estado !== "RECHAZADO") ?? false;
    let divEstado;

    if (estadoanulacion === "true" || anulado === "true") {
      divEstado = <div className={`lista-facturas-estado documento-anulado ${opciones.addClass ?? ''}`}>{'Anulado'}</div>;
    } else if (ajustado) {
      divEstado = <div className={`lista-facturas-estado documento-ajustado ${opciones.addClass ?? ''}`}>{'Ajustado'}</div>;
    } else if (estado === "RECHAZADO" || estadoContingencia === "RECHAZADO") {
      divEstado = <div className={`lista-facturas-estado documento-correo-invalido ${opciones.addClass ?? ''}`}>{'Rechazado'}</div>;
    } else if (enContingencia(data)) {
      divEstado = <div className={`lista-facturas-estado documento-contingencia ${opciones.addClass ?? ''}`}>{'Contingencia'}</div>;
    } else if (pasoPorContingencia(data)) {
      divEstado = (
        <div
          className={`lista-facturas-estado documento-contingencia-resuelta ${opciones.addClass ?? ''}`}
          title='Se emitió en contingencia y Hacienda ya lo certificó'
        >
          {'Procesado'}
        </div>
      );
    } else {
      divEstado = <div className={`lista-facturas-estado documento-activo ${opciones.addClass ?? ''}`}>{'Procesado'}</div>;
    }

    if (opciones.esTransaccion && notificarcorreo?.length > 0) {
      divEstado = (
        <>
          {divEstado}
          <div className='lista-facturas-estado documento-correo-invalido'>{'Fallo Último Correo'}</div>
        </>
      );
    }

    return divEstado;
  };
